// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2bTZ5","ranges":"BmiRanges_ranges__2UOqz"};